import SharedSendAlert from "../../Employer/SendAlert/SendAlert";

function AgencySendAlert() {
  return <SharedSendAlert mode="agency" />;
}

export default AgencySendAlert;
